export default function SummaryCard({ title, value, icon: Icon, color = 'cyan' }) {
  const styles = {
    cyan: {
      border: 'border-neon-cyan/30',
      bg: 'bg-neon-cyan/5',
      icon: 'bg-neon-cyan/10 text-neon-cyan',
      value: 'text-neon-cyan',
      shadow: 'hover:shadow-neon-cyan',
    },
    blue: {
      border: 'border-neon-blue/30',
      bg: 'bg-neon-blue/5',
      icon: 'bg-neon-blue/10 text-neon-blue',
      value: 'text-neon-blue',
      shadow: 'hover:shadow-neon-blue',
    },
    purple: {
      border: 'border-neon-purple/30',
      bg: 'bg-neon-purple/5',
      icon: 'bg-neon-purple/10 text-neon-purple',
      value: 'text-neon-purple',
      shadow: 'hover:shadow-neon-purple',
    },
    pink: {
      border: 'border-neon-pink/30',
      bg: 'bg-neon-pink/5',
      icon: 'bg-neon-pink/10 text-neon-pink',
      value: 'text-neon-pink',
      shadow: 'hover:shadow-neon-pink',
    },
    green: {
      border: 'border-neon-green/30',
      bg: 'bg-neon-green/5',
      icon: 'bg-neon-green/10 text-neon-green',
      value: 'text-neon-green',
      shadow: 'hover:shadow-neon-green',
    },
    amber: {
      border: 'border-neon-amber/30',
      bg: 'bg-neon-amber/5',
      icon: 'bg-neon-amber/10 text-neon-amber',
      value: 'text-neon-amber',
      shadow: 'hover:shadow-neon-amber',
    },
  };

  const s = styles[color] || styles.cyan;

  return (
    <div
      className={`rounded-2xl border ${s.border} ${s.bg} p-5 transition-all duration-300 ${s.shadow}`}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-slate-400">{title}</p>
          <p className={`mt-1.5 text-3xl font-bold ${s.value}`}>
            {value.toLocaleString()}
          </p>
        </div>
        {Icon && (
          <div className={`rounded-xl p-3 ${s.icon}`}>
            <Icon size={24} />
          </div>
        )}
      </div>
    </div>
  );
}
